
import { Component, Prop, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import SubjectSelectButton from '@/components/organisms/SubjectSelectButton.vue'
import ColorCurriculumUnitBox from '@/components/organisms/ColorCurriculumUnitBox.vue'
import { LearningStatusCurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 知識マップのおすすめ単元パネル
 */
@Component({
  components: {
    PanelFrame,
    ColorCurriculumUnitBox,
    SubjectSelectButton,
  },
})
export default class RecommendLearningMapPanel extends Vue {
  /** おすすめ単元のリスト(IDは増進堂単元ID) */
  @Prop()
  private recommendZnCurriculumUnits!: LearningStatusCurriculumUnit[] | null

  /** 項目ボックスクリック時のイベント */
  @Prop()
  private eventClickBox!: (id: number) => void
}
